import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap'
import { withRouter } from 'react-router'
import { getResponses } from '../../../actions/adminActions'
import { Link } from 'react-router-dom'
import { FaPlusSquare, FaEdit } from 'react-icons/fa'
import PropTypes from 'prop-types'

const FilterableTable = require('react-filterable-table')

class AdminResponses extends Component {
  componentWillMount () {
    this.props.getResponses()
  }

  render () {
    const renderEdit = (props) => {
      /*
       * This props object looks like this:
       * {
       *   value:  (value of the field in the data. In this case, it's the person's age.),
       *   record: (the data record for the whole row, in this case it'd be: { name: "Steve", age: 27, job: "Sandwich Eater" }),
       *   field:  (the same field object that this render function was passed into. We'll have access to any props on it, including that 'someRandomProp' one we put on there. Those can be functions, too, so we can add custom onClick handlers to our return value)
       * }
       */

      return (
        <Link className='btn-input btn btn-sm' to={`/admin/responses/${props.value}`}><FaEdit /> Edit</Link>
      )
    }
    // Fields to show in the table, and what object properties in the data they bind to
    const fields = [
      { name: 'name', displayName: 'Name', inputFilterable: true, sortable: true },
      { name: 'category', displayName: 'Category', inputFilterable: true, exactFilterable: true, sortable: true },
      { name: 'type', displayName: 'type', inputFilterable: true, exactFilterable: true, sortable: true },
      { name: 'id', displayName: '', inputFilterable: false, exactFilterable: false, sortable: false, render: renderEdit, tdClassName: 'text-right' }

    ]

    return (

      <div>
        <Row>
          <Col>
            <h1>Response Library</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <Breadcrumb>
              <BreadcrumbItem><Link to='/admin/responses'>Responses</Link></BreadcrumbItem>
              <BreadcrumbItem>List</BreadcrumbItem>

            </Breadcrumb>
          </Col>
        </Row>
        <Row className='content pt-2 pb-5'>
          <Col>
            {this.props.admin.loading
              ? <div className='table-loading-spinner' />
              : null }
            <FilterableTable
              namespace='Responses'
              initialSort='name'
              data={(this.props.admin.responses !== null) ? this.props.admin.responses : []}
              fields={fields}
              noRecordsMessage='There are no responses to display'
              noFilteredRecordsMessage='No match'
              topPagerVisible={false}
              tableClassName='table table-bordered'
            />
            <Link to='/admin/response/create' className='mt-2 btn btn-primary'><FaPlusSquare /> Create response</Link>

          </Col>

        </Row>

      </div>
    )
  }
};

AdminResponses.propTypes = {
  getResponses: PropTypes.func,
  admin: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getResponses
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminResponses))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminResponses/AdminResponses.jsx